<template>

  <v-card>
    <v-card-title>
      {{ file.path }}
    </v-card-title>

    <v-card-text>
      <file-preview :file="file" size="medium"></file-preview>
    </v-card-text>

    <v-card-actions class="justify-end">
      <v-btn text @click="close()">{{ $t('close') }}</v-btn>
      <v-btn text @click="download()">{{ $t('files.download') }}</v-btn>
      <v-btn text color="red" @click="remove()">{{ $t('files.delete') }}</v-btn>
    </v-card-actions>
  </v-card>

</template>

<script>
  import FilePreview from './file-preview'
  import i18n from '../../../i18n';

  export default {
    name: 'file-view-dialog',

    props: [ 'file' ],

    methods: {
      async remove () {
        const result = await this.$dialog.confirm({
          title: this.$t('delete-question'),
          text: this.$t('deleted-item-can-be-restored-notice'),
          actions: {
            true: {text: i18n.t('yes'), color: 'red'},
            false: {text: i18n.t('no'), color: 'black'}
          }
        })

        if (result)
          this.$emit('submit', { result: 'remove', file: this.file })
      },

      async download () {
        await this.$store.dispatch('getFile', { fileId: this.file.id })

        const link = document.createElement('a')
        document.body.appendChild(link)
        link.href = this.$store.state.files[this.file.id]['_orig']
        link.setAttribute('download', this.file.path)
        link.click()
        document.body.removeChild(link)
      },

      close () {
        this.$emit('submit', false)
      },
    },

    components: {
      FilePreview
    },
  }
</script>

<style scoped lang="scss">

  .v-card__text {
    padding: 0;
  }

  ::v-deep {
    .file {
      img {
        width: 100%;
      }

      .document {
        height: 200px;
      }
    }
  }

</style>
